// extracted by mini-css-extract-plugin
export default {"f":"_969e3211f9","main":"_8d28a617a3","btn":"_81d3c82632","w":"d06af2bc9b","h":"_2510a10673","lh25":"aa416af221","wb":"f3a1c014f6","b":"_730db1aec5","bx":"_6ee6e0f38f"};